goog.module('yext.developerapps.salesforcereviews.ListWorkflowsController');
goog.module.declareLegacyNamespace();

const SuccessToast = goog.require('yext.apps.common.SuccessToast');
const DialogView = goog.require('yext.apps.common.DialogView');
const yext = goog.require('yext');
const notify = goog.require('yext.notify');
const routes = goog.require('yext.developerapps.routes');

/**
 * @constructor
 */
const ListWorkflowsController = function() {
  this.$ctxt = $('.js-list-workflows');
  this.successToast = new SuccessToast();
  this.successToast.init();
  this.testTicketDialog = new DialogView(this.$ctxt.find('.js-test-ticket-dialog'));
  this.init();
};

ListWorkflowsController.prototype.init = function() {
  this.testTicketDialog.init();
  this.bindSendTestTicket();
  notify.init();
  notify.showUrlMessage();
};

ListWorkflowsController.prototype.bindSendTestTicket = function() {
  var controller = this;

  this.$ctxt.find('.js-send-test-ticket').on('click', function(event) {
    var $workflowDetails = $(this).closest('.js-workflow-details');
    var testCaseWorkflowName = $workflowDetails.find('.js-workflow-name').text();
    var $confirmTestTicketButton = controller.$ctxt.find('.js-confirm-test-ticket');

    controller.$ctxt.find('.js-test-ticket-workflow-name').text(testCaseWorkflowName);
    $confirmTestTicketButton.off();
    controller.testTicketDialog.show();

    $confirmTestTicketButton.on('click', function() {
      $.ajax({
        method: 'POST',
        url: routes.SalesforceReviews.createTestCase({'workflowId': $workflowDetails.data('id')}),
      }).done(function(result) {
        controller.testTicketDialog.hide();
        if (result['success']) {
          notify.showSuccess(yext.msg('A test case has been created according to your {0} workflow.', testCaseWorkflowName));
        } else {
          notify.showError(yext.msg('Failed to create test ticket.'));
        }
      });
    });
  });
};

goog.exportSymbol('yext.developerapps.salesforcereviews.ListWorkflowsController', ListWorkflowsController);

exports = ListWorkflowsController;
